











































import { Watch, Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { WxIDataDialog } from 'wax-lib';
@Component({ components: {} })
export default class Password extends Vue implements WxIDataDialog {
    // TODO: use actual type
    public $refs!: {
        form: any;
    };

    @Prop() private value!: boolean;
    @Prop() private passwordrule!: string;
    @PropSync('name', { type: String }) private syncedName!: string;

    private xShow = false;
    private message = '';
    private oldPassword = '';
    private newPassword1 = '';
    private newPassword2 = '';
    private valid = false;

    public showDialog() {
        this.show = true;
    }

    public closeDialog() {
        this.show = false;
    }

    public clearDialog() {
        if (this.$refs.form) this.$refs.form.reset();
        this.oldPassword = this.newPassword1 = this.newPassword2 = '';
    }

    @Watch('value')
    private hndlClose(value: boolean) {
        this.show = value;
    }

    private get passwordMatch() {
        return (v: string) => !this.newPassword2 || this.newPassword1 === this.newPassword2 || 'Password must match';
    }

    private get passwordMustChange() {
        return (v: string) => this.oldPassword !== this.newPassword1 || 'Password must not match';
    }

    private get show() {
        this.syncedName = 'changed' + this.xShow;
        return this.xShow;
    }

    private set show(value: boolean) {
        this.xShow = value;
        if (!value) this.clearDialog();
        this.$emit('input', value);
    }

    private hndlCancel() {
        this.closeDialog();
    }

    private hndlChange() {
        if (!this.$refs.form.validate()) return;

        this.message = '';

        this.$emit('passwordChanged', {
            oldPassword: this.oldPassword,
            newPassword1: this.newPassword1,
            newPassword2: this.newPassword2,
        });
    }
}
